/* eslint-disable react/jsx-no-bind */
import { number } from "common/formats";
import { Highcharts } from "extensions/highcharts";
import { useQuery } from "react-query";
import moment from "moment";
import {
    ColumnSeries,
    HighchartsChart,
    Chart,
    LineSeries,
    Tooltip,
    HighchartsProvider,
    XAxis,
    YAxis
} from "react-jsx-highcharts";
import { useSelector, shallowEqual } from "react-redux";
import classnames from "classnames";

import { getTickInterval, normalizeSeriesData, plotOptions, dateTimeLabelFormats } from "common/components/charts/react/utils";
import { toHex } from "common/colors";
import { fetchRequests } from "common/actions/requests";

import { Placeholder } from "common/components/placeholder";

export function ReduxTrendChart({
    className
}) {
    const queryDeps = useSelector((state) => ({
        date_range: state.common.date_range,
        qualifiers: state.requests.qualifiers
    }), shallowEqual);
    const { data, status } = useQuery(["requests", { pivots: ["date_time"], ...queryDeps }], fetchRequests);

    const YAxisProps = {
        labels: {
            format: "{value:,.0f}"
        }
    };
    
    const leftSeries = [{
        name: "Average request time",
        pointFormat: ["date_time", "average_request_time"],
        color: toHex("green-leaf"),
        valueType: "number",
        zIndex: 2
    }];
    
    const rightSeries = [{
        name: "Total requests",
        pointFormat: ["date_time", "requests_count"],
        color: toHex("blue-light"),
        valueType: "number",
        zIndex: 1
    }];
    
    const tooltipFormatter = function(tooltip, x = this.x, points = this.points) {
        const points_data = points.map((point) => {
            if (point.series.name === "Total requests") {
                return `${point.series.name}: ${number(point.y)}`;
            }
            return `${point.series.name}: ${number(point.y, 2)}ms`;
        });
        
        return `<b>${moment.utc(x).format("dddd, MMM D YYYY")}</b><br/>${points_data.join("<br/>")}`;
    };
    
    return (
        <div className={classnames("chart", className)}>
            {status === "loading" && <Placeholder/>}
            {status === "success" && (
                <HighchartsProvider Highcharts={Highcharts}>
                    <HighchartsChart plotOptions={plotOptions}>
                        <Chart backgroundColor="transparent" />
                        <Tooltip
                            formatter={tooltipFormatter}
                            shared
                            crosshairs
                            dateTimeLabelFormats={dateTimeLabelFormats}
                        />
                        
                        <XAxis type="datetime" dateTimeLabelFormats={dateTimeLabelFormats} {...getTickInterval()} />
                        
                        <YAxis {...YAxisProps}>
                            <YAxis.Title>Average request duration (in ms)</YAxis.Title>
                            {normalizeSeriesData(data, leftSeries).map((s, i) => <LineSeries {...s} key={i++} />)}
                        </YAxis>
                        
                        <YAxis {...YAxisProps} opposite>
                            <YAxis.Title>Total requests</YAxis.Title>
                            {normalizeSeriesData(data, rightSeries).map((s, i) => <ColumnSeries {...s} key={i++} />)}
                        </YAxis>
                    </HighchartsChart>
                </HighchartsProvider>
            )}
        </div>
    );
}
